import { Component } from "@angular/core";

@Component({
    selector: "pagenotfound",
    templateUrl: "./pagenotfound.component.html",
    standalone: false
})

export class PageNotFoundComponent {
    title = "Under Construction";
}